import axios from '@/libs/api.request'

const firstDefined = (...values) => values.find(value => value !== undefined)

export const toAgentViewModel = (item = {}) => {
  const ownerUserId = firstDefined(item.ownerUserId, item.owner_user_id)
  const rawStatus = firstDefined(item.status, 0)
  const parentAgentId = firstDefined(item.parentAgentId, item.parent_agent_id)

  return {
    id: item.id,
    name: item.name || '',
    parentAgentId: parentAgentId == null || parentAgentId === '' ? null : Number(parentAgentId),
    ownerUserId: ownerUserId === null || ownerUserId === '' ? undefined : Number(ownerUserId),
    ownerUserName: firstDefined(item.ownerUserName, item.owner_user_name) || '-',
    contactName: firstDefined(item.contactName, item.contact_name) || '',
    phone: item.phone || '',
    status: Number(rawStatus) === 1 ? 1 : 0,
    createTime: firstDefined(item.createTime, item.create_time) || '',
    updateTime: firstDefined(item.updateTime, item.update_time) || ''
  }
}

export const toOwnerOption = (item = {}) => ({
  id: Number(item.id),
  username: item.username || '',
  realName: firstDefined(item.realName, item.real_name) || '',
  phone: item.phone || '',
  status: ![false, 0, '0', 'false'].includes(item.status)
})

export const buildAgentPayload = (form = {}) => {
  const ownerUserId = Number(form.ownerUserId)
  if (!ownerUserId) throw new Error('请选择负责人账号')
  if (form.status !== 0 && form.status !== 1) throw new Error('请选择正确的状态')
  const hasParent = form.parentAgentId !== undefined && form.parentAgentId !== null && form.parentAgentId !== ''
  const parentAgentId = Number(form.parentAgentId)
  if (hasParent && (!Number.isInteger(parentAgentId) || parentAgentId <= 0)) throw new Error('请选择有效的上级代理商')

  return {
    name: String(form.name || '').trim(),
    ownerUserId,
    contactName: String(form.contactName || '').trim(),
    phone: String(form.phone || '').trim(),
    status: form.status,
    ...(hasParent ? { parentAgentId } : {})
  }
}

const normalizePageResponse = (res) => {
  if (!res.data || res.data.code !== 200 || !res.data.data) return res
  const page = res.data.data
  const records = Array.isArray(page.records) ? page.records : []
  return {
    ...res,
    data: {
      ...res.data,
      data: {
        ...page,
        records: records.map(toAgentViewModel)
      }
    }
  }
}

const normalizeInfoResponse = (res) => {
  if (!res.data || res.data.code !== 200 || !res.data.data) return res
  return {
    ...res,
    data: {
      ...res.data,
      data: toAgentViewModel(res.data.data)
    }
  }
}

const normalizeUserPageResponse = (res) => {
  if (!res.data || res.data.code !== 200 || !res.data.data) return res
  const page = res.data.data
  const records = Array.isArray(page.records) ? page.records : []
  return {
    ...res,
    data: {
      ...res.data,
      data: {
        ...page,
        records: records.map(toOwnerOption)
      }
    }
  }
}

export const getAgentList = (params) => {
  return axios.request({
    url: 'agent/list',
    params,
    method: 'get'
  }).then(normalizePageResponse)
}

export const getCurrentAgentContext = () => axios.request({
  url: 'agent/current-context',
  method: 'get'
})

export const getDirectChildAgents = (parentAgentId) => axios.request({
  url: 'agent/direct-children',
  params: { parentAgentId },
  method: 'get'
}).then(res => {
  if (!res.data || res.data.code !== 200 || !Array.isArray(res.data.data)) return res
  return { ...res, data: { ...res.data, data: res.data.data.map(toAgentViewModel) } }
})

export const getAgentInfo = (id) => {
  return axios.request({
    url: 'agent/info',
    params: { id },
    method: 'get'
  }).then(normalizeInfoResponse)
}

export const getAgentOwnerOptions = (params) => {
  return axios.request({
    url: 'user/list',
    params,
    method: 'get'
  }).then(normalizeUserPageResponse)
}

export const addAgent = (data) => {
  return axios.request({
    url: 'agent/add',
    data,
    method: 'post'
  })
}

export const getAgentOwnerCreationContext = ownerUserId => axios.request({
  url: 'agent/owner-creation-context',
  params: { ownerUserId },
  method: 'get'
})

export const editAgent = (id, data) => {
  return axios.request({
    url: `agent/edit/${id}`,
    data,
    method: 'put'
  })
}

export const changeAgentParent = (id, data) => axios.request({
  url: `agent/${id}/parent`,
  data,
  method: 'put'
})

export const deleteAgent = (id) => {
  return axios.request({
    url: `agent/delete/${id}`,
    method: 'delete'
  })
}
